import { generateApiPath } from "@routes/generatePath.ts";
import { attend } from "@api/msp/appointments/attend/path";
import type { IExtractParams } from "@routes/types";

const pathBase = `/medical-service-provider/appointments`;
const pathById = `/medical-service-provider/appointments/:appointmentId`;

export type IPathByIdParams = IExtractParams<typeof pathById>;

export const appointments = {
  getAll: () => generateApiPath(pathBase),
  get: (params: IPathByIdParams) => generateApiPath(pathById, params),
  attend,
};
